<div class="toggle-buttons">
  <button class="btn btn-icon btn-grid"  (click)="showGridView()" [ngClass]="{'selected': isGridSelected}">
    <img [src]="isGridSelected ? '/assets/img/icons/dots-white.svg' : '/assets/img/icons/dots.svg' " alt="grid view">
  </button>
  <button class="btn btn-icon btn-list" (click)="showListView()" [ngClass]="{'selected': !isGridSelected}">
    <img [src]="isGridSelected ? '/assets/img/icons/menu.svg' : '/assets/img/icons/menu-white.svg'" alt="list view">
  </button>
</div>
